export function getPrice(price: number, taxRate: number, withTax: boolean) {
	const tax = calcTaxAmount(price, taxRate, !withTax, false);

	return withTax ? price + tax : price - tax;
}

export function calcTaxAmount(
	price: number,
	taxRate: number,
	priceIncludeTax = false,
	round = true,
) {
	let amount = 0;
	const taxAmount = taxRate / 100;

	if (priceIncludeTax) {
		amount = price * (1 - 1 / (1 + taxAmount));
	} else {
		amount = price * taxAmount;
	}

	if (round) {
		return Math.round(amount);
	}

	return amount;
}
